import React, { useEffect, useState, useRef,useContext } from 'react';
import { ContenedorParametros } from "../components/utils/ContenedorParametros";
import { ContenedorTabla } from '../components/utils/ContenedorTabla';
import { Modal } from '../components/modal/Modal';
import { UserContext } from '../../context/provider/UserProvider';
import { BotonNuevo } from '../components/buttons/BotonNuevo';
import { useModal } from '../../hooks/useModal';
import { notify, soloNumero } from '../../utils/utils';
import { useRecargas } from '../../hooks/useRecargas';
import { BotonProcesar } from '../components/buttons/BotonProcesar';
import { useOperaciones } from '../../hooks/useOperaciones';
import { Tooltip } from '../components/utils/Tooltip';
import { DatePickerDoble } from '../components/pickers/DatePickerDoble';


export const OperacionesResumen =()=>{

    const { stateUser, signOut } = useContext(UserContext)
    const [ startDate, setStartDate ] = useState(new Date())
    const [ endDate, setEndDate ] = useState(new Date())

    const {         
        listarOperaciones,
        verificarInicioOperacion,
        operaciones,
        operacion,
        iniciarOperacion,
        finalizarOperacion,
        operacionActiva,
        resumenMontoOperaciones,
        isOpenModalResumenMonto ,
        closeModalResumenMonto,
        listarResumenMontos,
        isOpenModalIncioOperacion,
        openModalInicioOperacion,
        closeModalInicioOperacion
    } = useOperaciones()

    const {
        bancos,
        } = useRecargas();

    const [ operacionFinalizar, setOperacionFinalizar ] = useState();
    const [ montosPorEntidad, setMontosPorEntidad ] = useState([]);

    const cambiarMontoEntidad = (index, monto, codEntidad) => {
        const newMontos = [...montosPorEntidad];
        newMontos[index] = {
            monto: monto,
            codEntidadBancaria: codEntidad
        };
        setMontosPorEntidad(newMontos);
    };

    const registrarOperacion = () => {
        const operacion = {
            uid: stateUser.uid,
            listaDetallaMovimiento: montosPorEntidad.map(item => ({
                monto: item.monto,
                codEntidadBancaria: item.codEntidadBancaria
            }))
        };
        iniciarOperacion(operacion)
    };

    useEffect(()=>{
        listarOperaciones(startDate, endDate)
    },[startDate, endDate])

return(
    <>
        <ContenedorParametros titulo="Operaciones">
            <DatePickerDoble
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
            />
            <BotonNuevo onClick={()=>openModalInicioOperacion()}>NUEVO</BotonNuevo>
        </ContenedorParametros>
        <ContenedorTabla>
                <div className='containerScroll  mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                    <table className="table ">
                        <thead>
                            <tr>
                                <th className="text-center">N</th>
                                <th className="text-center">CODIGO</th>
                                <th className="text-center">FECHA HORA INICIO </th>
                                <th className='text-center'>FECHA HORA FIN</th>
                                <th className="text-center">USUARIO</th>
                                <th className="text-center"></th>
                                <th className="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            operaciones?.length > 0
                            ? operaciones?.map((operacion, i) => {
                                return (
                                    <tr key={operacion.codUsuarioOperacion}>
                                        <td className='text-center'>{ ++i}</td>
                                        <td className="text-center">{operacion.codUsuarioOperacion}</td>
                                        <td className="text-center">{operacion.fechaHoraInicio}</td>
                                        <td className="text-center">{operacion.fechaHoraFin}</td>
                                        <td className="text-center">{operacion.nomUsuario}</td>
                                        <td className="text-center">{operacion.nomEstado}</td>
                                        <td 
                                            className="text-center"
                                            onClick={()=>{setOperacionFinalizar(operacion);listarResumenMontos(operacion.codUsuarioOperacion)}}
                                        >
                                            <i  data-tip data-for={'toolCierreOperacion'}  className="text-yellow-500 text-xl fa fa-money"></i>
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                        </tbody>
                    </table>
                </div>´

                <Tooltip id={'toolCierreOperacion'}>
                    {`Finalizar Operaciones de usuario`}
                </Tooltip>

        </ContenedorTabla>

        <Modal
            isOpen={isOpenModalIncioOperacion}
            closeModal={closeModalInicioOperacion}
            action={registrarOperacion}
            title="Iniciar Operaciones"
            spinner={{}}
            textButtons={{ confirm: 'Iniciar Operaciones', denied: 'Cerrar' }}
            validButton={{ confirm: true, denied: true }}
        >
            <div className="flex gap-8 items-center flex-wrap justify-center">
                <div className="w-[450px] flex flex-col px-4">
                        <span>Ingrese los montos iniciales de los bancos (Referencial)</span>
                    <div className='containerScroll  mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                        <table className="table">
                        {/* <thead>
                            <tr>
                                <th className="text-center">N</th>
                                <th className="text-center">CODIGO</th>
                                <th className="text-center">FECHA HORA INICIO </th>
                                <th className='text-center'>FECHA HORA FIN</th>
                                <th className="text-center">USUARIO</th>
                                <th className="text-center"></th>
                                <th className="text-center"></th>
                            </tr>
                        </thead> */}
                            <tbody>
                                {bancos?.length > 0
                                    ? bancos?.map((banco, index) => (
                                        <tr key={banco.codEntidadBancaria} 
                                        className='text-xl'
                                        >
                                            <td className='text-left'>{banco.codEntidadBancaria}</td>
                                            <td className="text-left w-[300px]">
                                                {banco.abrevEntidadBancaria} ({banco.cuentaBancaria})
                                            </td>
                                            <td className="text-left w-[150px]    ">
                                                <span 
                                                    className='px-1 text-lg'
                                                >
                                                    S/ 
                                                </span>
                                                <input
                                                    className={`text-white h-[30px] rounded caret-white px-2 w-[100px] bg-zinc-900 text-lg focus:outline-none focus:ring-1 focus:ring-blue-500`}
                                                    defaultValue={0.00}
                                                    onChange={(e) => cambiarMontoEntidad(index, e.target.value, banco.codEntidadBancaria)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                    : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal> 

        <Modal 
            isOpen={isOpenModalResumenMonto} 
            closeModal={closeModalResumenMonto} 
            action={()=>finalizarOperacion(operacionFinalizar.codUsuarioOperacion)}
            title= {`Finalizar Operaciones [ ${operacionFinalizar?.codUsuarioOperacion} - ${operacionFinalizar?.nomUsuario}]`}
            spinner={{}}
            textButtons={{ confirm: 'Finalizar Operaciones', denied: 'Cancelar' }}
        >
            <div className="text-center flex gap-8 items-center flex-wrap justify-center">      
                <div className="w-[400px] px-4">
                <div className="flex gap-8 items-center flex-wrap justify-center">
                <div className="w-[400px] flex flex-col px-4">
                    <span className='text-xl'>Resumen de montos recaudado</span>
                    <div className='containerScroll  mt-3 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                        <table className="table">
                            <thead>
                                <tr>
                                    {/* <th className="text-center">N</th> */}
                                    <th className="text-left">BANCO</th>
                                    <th className="text-center">MONTO INCIAL</th>
                                    <th className='text-center'>MONTO ACUMULADO</th>
                                    <th className="text-center">MONTO FINAL</th>
                                    {/* <th className="text-center"></th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {resumenMontoOperaciones?.length > 0
                                    ? resumenMontoOperaciones?.map((rmo, index) => (
                                        <tr key={rmo.codEntidadBancaria}>
                                            {/* <td className='text-left'>{rmo.codEntidadBancaria}</td> */}
                                            <td className="text-left ">{rmo.abrevEntidadBancaria}</td>
                                            <td className="text-center">S/{rmo.montoInicial}</td>
                                            <td className="text-center">S/{rmo.montoAcumulado}</td>
                                            <td className="text-center">S/{(rmo.montoInicial) + (rmo.montoAcumulado) }</td>
                                        </tr>
                                    ))
                                    : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
                </div>
            </div>
        </Modal>
    </>


)


}